import type { ComputedRef, Ref } from 'vue'
import type { EsProductFragment } from '#graphql-operations'

export default function useBynderAssets(product: Ref<EsProductFragment> | ComputedRef<EsProductFragment>) {
  const media = computed(() => {
    return (product.value?.media ?? [])
      .filter(item => item !== null && item !== undefined)
      .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
  })

  const images = computed(() => media.value.filter(item => item.type === 'image'))
  const videos = computed(() => {
    const items = media.value.filter(item => item.type === 'video')

    return {
      desktop: items.find(item => item.device === 'desktop') ?? null,
      mobile: items.find(item => item.device === 'mobile') ?? null,
    }
  })

  const ambiance = computed(() => {
    const ambiance = images.value.filter(item => item.category === 'ambiance')

    return {
      desktop: ambiance.filter(item => item.device === 'desktop'),
      mobile: ambiance.filter(item => item.device === 'mobile'),
    }
  })

  const highlights = computed(() => media.value.filter(item => item.category === 'highlight'))

  const threeDModel = computed(() => ({
    glb: media.value.find(item => item.category === 'glb')?.src || '',
    usdz: media.value.find(item => item.category === 'usdz')?.src || '',
  }))

  return {
    media,
    images,
    videos,
    ambiance,
    highlights,
    threeDModel,
  }
}





